import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { driver } from 'src/app/drivers/shared/models/driver.model';
import { environment } from 'src/environments/environment';
import { devices } from '../models/devices.model';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {
  headers={ securtyToken: 'string'}
  
  constructor(private http:HttpClient ) {
    
   }
   
   GetDevices(pageNo: number, pageSize: number) : Observable<any>{

    return this.http.get<any>(`${environment.config.BASE_API_URL}Device/GetDevices?pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  GetDrivers() : Observable<any>{
    return this.http.get<any>(environment.config.BASE_API_URL + "Device/GetBlankDevice");
  }

postDevice(mod : devices) : Observable<any>{
          const headers = {'Authorization': 'Basic TGluZGE6QWRtaW4xMjM0OkVtcGxveWVl', 'Accept': "application/json", "Content-Type": "application/json"};
          return this.http.post<any>('http://dcdapi.ssasoft.com/api/Device/PostDevice',mod, { headers });
        }      
};


